import React, { lazy, Suspense, useEffect, useState } from "react";
import { Redirect, Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
// import { BuilderPage } from "./pages/BuilderPage";
// import { MyPage } from "./pages/MyPage";
import { DashboardPage } from "./pages/DashboardPage";
import axios from "axios";
// import Penyedia from "./modules/Penyedia/Penyedia";
// import PenyediaRoutes from "./modules/Penyedia/PenyediaRoutes";
// import MonitoringRoutes from "./modules/Monitoring/MonitoringRoutes";
import { useSelector } from "react-redux";

// const MonitoringPages = lazy(() =>
//   import("./modules/Monitoring/MonitoringRoutes")
// );
// const PenyediaPages = lazy(() => import("./modules/Penyedia/PenyediaRoutes"));
const KontraktorPages = lazy(() =>
  import("./modules/Kontraktor/KontraktorRoutes")
);
const BkpjkpPages = lazy(() => import("./modules/BarangJasa/BarangJasaRoutes"));
const MainPages = lazy(() => import("./modules/Main/Main"));
export default function BasePage() {
  // useEffect(() => {
  //   console.log('Base page');
  // }, []) // [] - is required if you need only one call
  // https://reactjs.org/docs/hooks-reference.html#useeffect
  const { REACT_APP_MENU_URL } = process.env;
  const { role } = useSelector((state) => state.auth);

  const [menu, setMenu] = useState([]);
  const granted = role.includes("ROLE_USERFASIN");

  const getMenu = async () => {
    try {
      const data = {
        role: ["99", "8"],
        route: "dashboard",
      };
      const response = await axios.post(`${REACT_APP_MENU_URL}`, data);
      return response;
    } catch (err) {
      if (err.response) {
        console.log(err.response);
      } else {
        console.log(err);
      }
    }
  };

  useEffect(() => {
    // getMenu()
    // .then(({data: {data}})=> {
    //   setMenu(data.menu);
    // })
  }, []);

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          // <Redirect exact from="/" to="/dashboard" />
        }

        {granted ? (
          <Redirect exact from="/" to="/dashboard" />
        ) : (
          <Redirect from="/" to="/error" />
        )}
        <ContentRoute path="/dashboard" component={DashboardPage} />
        {granted ? (
          <ContentRoute path="/kontraktor" component={KontraktorPages} />
        ) : (
          <Redirect from="/kontraktor" to="/error" />
        )}
        {granted ? (
          <ContentRoute path="/bkpjkp" component={BkpjkpPages} />
        ) : (
          <Redirect from="/bkpjkp" to="/error" />
        )}
         {granted ? (
          <ContentRoute path="/main" component={MainPages} />
        ) : (
          <Redirect from="/main" to="/error" />
        )}
        {/* <ContentRoute path="/kontraktor" component={KontraktorPages} /> */}
        {/* <ContentRoute path="/bkpjkp" component={BkpjkpPages} /> */}
        {/* <ContentRoute path="/main" component={MainPages} /> */}
        {/* <ContentRoute path="/monitoring" component={MonitoringPages} />
        <ContentRoute path="/penyedia" component={PenyediaPages} /> */}
        {/* <ContentRoute path="/builder" component={BuilderPage} /> */}
        {/* <ContentRoute path="/my-page" component={MyPage} /> */}
        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
